export default class CDN{
    public static createUrl(path: string): string {
        return `${process.env.VUE_APP_CDN}/${path}`;
    }

}
